import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=0dcf35e8&scoped=true&"
import script from "./ModalConfirm.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ModalConfirm.vue?vue&type=style&index=0&id=0dcf35e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf35e8",
  null
  
)

export default component.exports